<template>
    <div class="landing-page" v-if="!$auth.loading">
        <svg class="landing-defs" aria-hidden="true">
            <defs>
                <symbol id="landing-bolt" viewBox="0 0 100 150" fill="currentColor">
                    <polygon points="58,0 18,86 46,86 38,150 88,58 56,58" />
                </symbol>
                <symbol id="landing-spark" viewBox="0 0 24 24" fill="currentColor">
                    <path
                        d="M12 0c.7 6 1.3 8.4 4.2 9.6C13.4 10.8 12.7 13.2 12 24c-.7-10.8-1.4-13.2-4.2-14.4C10.6 8.4 11.3 6 12 0Z"
                    />
                </symbol>
                <symbol id="landing-check" viewBox="0 0 12 12" fill="none">
                    <path
                        d="M2.5 6.2l2 2L9.5 3.5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </symbol>
            </defs>
        </svg>

        <div class="split">
            <section class="brand" aria-label="Бренд-зона">
                <div class="deco" aria-hidden="true">
                    <span class="ring r1"></span>
                    <span class="ring r2"></span>
                    <span class="diamond"></span>
                    <span class="diamond sm"></span>
                    <svg class="bolt" viewBox="0 0 100 150"><use href="#landing-bolt" /></svg>
                    <svg
                        v-for="spark in sparks"
                        :key="spark"
                        :class="['spark', spark]"
                        viewBox="0 0 24 24"
                    >
                        <use href="#landing-spark" />
                    </svg>
                </div>
                <div class="brand-inner">
                    <div class="brand-top">
                        <div class="logo" aria-label="Data Heroes">
                            <img class="brand-logo-img" :src="logoSrc" alt="Data Heroes" />
                        </div>
                        <a :href="`tel:${headerPhoneTel}`" class="header-phone">{{ headerPhone }}</a>
                    </div>
                    <span class="eyebrow">
                        <svg viewBox="0 0 100 150" width="11" height="15"><use href="#landing-bolt" /></svg>
                        CRM-маркетинг для сферы услуг
                    </span>
                    <h1>
                        Не просто бот<br />
                        для рассылок —<br />
                        <em>система роста</em> <span class="ind">выручки</span>
                    </h1>
                    <p class="brand-sub">
                        Собираем данные, анализируем каждого клиента, управляем коммуникациями и показываем,
                        <b>где бизнес теряет деньги.</b>
                    </p>
                    <div class="stats">
                        <div v-for="stat in stats" :key="stat.label[0]" class="stat">
                            <div class="v">
                                <em v-if="stat.em">{{ stat.em }}</em>{{ stat.value }}
                            </div>
                            <div class="l">
                                <span v-for="(line, i) in stat.label" :key="i">
                                    <br v-if="i" />{{ line }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="actions" aria-label="Зона действий">
                <div class="actions-top" aria-label="Быстрый вход">
                    <button
                        v-for="action in authNav"
                        :key="action.mode"
                        type="button"
                        class="btn btn-nav"
                        :class="action.className"
                        @click="openAuthDialog(action.mode)"
                    >
                        {{ action.label }}
                    </button>
                </div>

                <div class="actions-main">
                    <div class="door door-platform">
                        <span class="door-num">01</span>
                        <div class="door-head">
                            <div class="door-icon icon-platform">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M3 3v18h18"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M7 14l3.5-4 3 2.5L21 6"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                            <div class="door-htext">
                                <span class="door-kicker"><span class="d"></span>CRM-платформа</span>
                                <div class="door-title">Личный кабинет</div>
                            </div>
                        </div>
                        <p class="door-desc">
                            Возврат клиентов, сегменты, рассылки, звонки, аналитика и KPI сотрудников — всё в
                            едином окне.
                        </p>
                        <div class="tags">
                            <span v-for="tag in platformTags" :key="tag" class="tag">
                                <svg viewBox="0 0 12 12"><use href="#landing-check" /></svg>
                                {{ tag }}
                            </span>
                        </div>
                        <div class="door-foot">
                            <div class="auth-cta">
                                <button
                                    type="button"
                                    class="btn btn-indigo"
                                    @click="openAuthDialog('login')"
                                >
                                    <svg viewBox="0 0 15 15" width="15" height="15" fill="none">
                                        <path
                                            d="M3 7.5h8M8 3.5l4 4-4 4"
                                            stroke="currentColor"
                                            stroke-width="1.6"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    Вход
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-outline"
                                    @click="openAuthDialog('register')"
                                >
                                    Регистрация
                                </button>
                            </div>
                            <button
                                type="button"
                                class="btn btn-ghost link-try"
                                @click="openAuthDialog('register', { openCreateProjectAfterRegister: true })"
                            >
                                <b>14 дней</b>&nbsp;бесплатно →
                            </button>
                            <div class="pmeta">
                                <div class="pv">от 2 743 ₽</div>
                                <div class="pl">в месяц · до 15% возврата</div>
                            </div>
                        </div>
                    </div>

                    <div class="door door-market">
                        <span class="door-num">02</span>
                        <div class="market-row">
                            <div class="icon-market">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M4 8h16l-1 4H5L4 8z"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M4 8l-.7-3H2M5 12l1 7h12l1-7"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                            <div class="market-text">
                                <span class="ad-label">
                                    Маркетплейс Data Heroes <span class="b">реклама</span>
                                </span>
                                <div class="market-title">Готовые решения для роста</div>
                                <p class="market-desc">
                                    CRM-настройка, обучение, скрипты, интеграции, аудиорассылки и другие решения от
                                    команды и экспертов рынка — доступны без аккаунта.
                                </p>
                            </div>
                            <router-link to="/marketplace" class="btn btn-wasabi">
                                <svg viewBox="0 0 15 15" width="15" height="15" fill="none">
                                    <path
                                        d="M2.5 4h10l-1 5.5H4L2.5 4z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linejoin="round"
                                    />
                                    <circle cx="5.5" cy="12.5" r="1" fill="currentColor" />
                                    <circle cx="10.5" cy="12.5" r="1" fill="currentColor" />
                                </svg>
                                Открыть маркетплейс
                            </router-link>
                        </div>
                    </div>

                    <footer class="door door-system-footer" aria-label="Футер Data Heroes">
                        <div class="system-integrations" aria-label="Интеграции">
                            <span class="int-label">Интеграции:</span>
                            <span v-for="name in integrations" :key="name" class="int-chip">{{ name }}</span>
                        </div>
                        <div class="system-footer-separator" aria-hidden="true"></div>
                        <div class="system-footer-grid">
                            <div class="system-footer-contact" aria-label="Контакты Data Heroes">
                                <a
                                    v-for="contact in contacts"
                                    :key="contact.href"
                                    :href="contact.href"
                                >{{ contact.label }}</a>
                            </div>
                            <div class="system-footer-support" aria-label="Поддержка">
                                <span class="system-footer-support-title">Поддержка</span>
                                <a
                                    v-for="link in supportLinks"
                                    :key="link.href"
                                    class="system-support-btn"
                                    :class="{ 'system-support-btn--secondary': link.secondary }"
                                    :href="link.href"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >{{ link.label }}</a>
                            </div>
                        </div>
                        <div class="system-footer-bottomline">
                            <span class="system-copy">© 2026 Data Heroes</span>
                            <span class="system-grant-note"
                                >При поддержке ФСИ в рамках федерального проекта «Отечественные решения»</span
                            >
                        </div>
                    </footer>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Landing',
    data: () => ({
        logoSrc: require('@/assets/Logo_light.svg'),
        headerPhone: '+7 (964) 726-74-76',
        headerPhoneTel: '+79647267476',
        sparks: ['a', 'b', 'c'],
        stats: [
            { em: '8,7', value: ' млрд\u00a0₽', label: ['заработано', 'клиентами'] },
            { value: '1\u00a0500+', label: ['салонов', 'с нами'] },
            { value: '3–5 дней', label: ['до запуска', 'под ключ'] },
        ],
        authNav: [
            { label: 'Вход', mode: 'login', className: 'btn-nav-login' },
            { label: 'Регистрация', mode: 'register', className: 'btn-nav-signup' },
        ],
        platformTags: [
            'Возврат потеряшек',
            'Сегменты и рассылки',
            'Звонки и аналитика',
            'KPI сотрудников',
        ],
        integrations: ['YCLIENTS', '1С', 'Altegio', 'Arnica', 'Dikidi', 'Профсалон', 'и другие'],
        contacts: [
            { label: 'info@dataheroes.pro', href: 'mailto:info@dataheroes.pro' },
            { label: '+7 965 105 71 94', href: 'tel:+79651057194' },
        ],
        supportLinks: [
            { label: 'Telegram', href: 'https://t.me/dataheroes_bot' },
            { label: 'MAX', href: 'https://max.ru/id7707452371_bot', secondary: true },
        ],
    }),
    methods: {
        openAuthDialog(startSection, options = {}) {
            this.$store.commit(
                'setOpenCreateProjectAfterRegister',
                Boolean(options.openCreateProjectAfterRegister)
            )
            this.$store.commit('setAuthDialogStartSection', startSection)
            this.$store.commit('setIsAuthDialog', true)
        },
    },
}
</script>

<style lang="sass">

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap')
@import '@/vars.sass'

.landing-page
    --ink: #{$dark-new}
    --ink2: #202040
    --ink3: #2C2C50
    --indigo: #{$main-new}
    --indigo-d: #454CC0
    --indigo-l: #7C83E8
    --wasabi: #{$pop-new}
    --wasabi-d: #A8BE00
    --indigo-tint: #{$bcg-card-new}
    --wasabi-tint: #F6FBE3
    --bg: #{$app-bcg-new}
    --surface: #FFFFFF
    --surface-soft: #FBFCFF
    --line: #{$border-new}
    --line2: #{$border-light-new}
    --text: #{$text-color-new}
    --mut: #{$muted-new}
    --mut2: #{$muted-light-new}
    --r-md: 14px
    --r-lg: 20px
    --r-xl: 24px
    --sh-md: 0 12px 32px rgba($dark-new, .10)

    box-sizing: border-box
    height: 100vh
    min-height: 0
    overflow: hidden
    font-family: 'Inter', system-ui, sans-serif
    font-size: 14px
    background: var(--bg)
    color: var(--text)
    -webkit-font-smoothing: antialiased

    .landing-defs
        position: absolute
        width: 0
        height: 0
        overflow: hidden

    *, *::before, *::after
        box-sizing: border-box

    a
        text-decoration: none
        color: inherit

    .split
        display: grid
        grid-template-columns: 0.92fr 1.08fr
        height: 100vh
        min-height: 0

    .brand
        position: relative
        background: var(--ink)
        color: #fff !important
        padding: 44px 48px
        display: flex
        flex-direction: column
        overflow: hidden
        border-right: 3px solid var(--wasabi)

        &::before
            content: ''
            position: absolute
            inset: 0
            background-image: radial-gradient(rgba(255, 255, 255, .05) 1.2px, transparent 1.2px)
            background-size: 22px 22px
            pointer-events: none

        &::after
            content: ''
            position: absolute
            width: 520px
            height: 520px
            right: -220px
            top: -160px
            border-radius: 50%
            background: radial-gradient(circle, rgba($main-new, .55), transparent 68%)
            filter: blur(20px)
            pointer-events: none

    .brand-inner
        position: relative
        z-index: 2
        display: flex
        flex-direction: column
        height: 100%

    .deco
        position: absolute
        inset: 0
        z-index: 1
        pointer-events: none
        overflow: hidden

        .bolt
            position: absolute
            right: 30px
            bottom: 34px
            width: 150px
            color: var(--wasabi)
            opacity: .14
            transform: rotate(6deg)

        .ring
            position: absolute
            border-radius: 50%
            border: 1.5px solid rgba(255, 255, 255, .07)

            &.r1
                width: 260px
                height: 260px
                right: -90px
                top: 46px

            &.r2
                width: 158px
                height: 158px
                right: -18px
                top: 97px
                border-color: rgba($pop-new, .16)

        .diamond
            position: absolute
            width: 64px
            height: 64px
            border: 1.5px solid rgba(124, 131, 232, .45)
            left: 58%
            top: 34%
            transform: rotate(45deg)

            &.sm
                width: 30px
                height: 30px
                left: 40%
                bottom: 16%
                border-color: rgba($pop-new, .3)

        .spark
            position: absolute
            color: var(--wasabi)
            opacity: .85

            &.a
                width: 26px
                left: 50%
                top: 21%

            &.b
                width: 15px
                left: 84%
                top: 54%
                opacity: .6

            &.c
                width: 18px
                left: 30%
                top: 9%
                opacity: .5

    .brand-top
        display: flex
        align-items: center
        justify-content: space-between
        gap: 16px
        flex-wrap: nowrap

    .logo
        display: inline-flex
        align-items: center
        min-width: 0
        flex-shrink: 0
        pointer-events: none

    .brand-logo-img
        display: block
        width: 142px
        height: auto
        max-height: 42px
        object-fit: contain
        object-position: left center

    .header-phone
        font-family: 'Geologica', sans-serif
        font-size: 13px
        font-weight: 700
        color: var(--wasabi) !important
        letter-spacing: -.01em
        white-space: nowrap
        flex-shrink: 0

    .eyebrow
        display: inline-flex
        align-items: center
        gap: 9px
        font-family: 'Geologica', sans-serif
        font-size: 11px
        font-weight: 800
        letter-spacing: .12em
        text-transform: uppercase
        color: var(--wasabi) !important
        margin-top: 34px
        margin-bottom: auto

    .brand h1
        font-family: 'Geologica', sans-serif
        font-size: clamp(30px, 3.4vw, 44px)
        font-weight: 900
        letter-spacing: -.045em
        line-height: 1.02
        margin: 30px 0 0
        color: #fff !important

        em
            font-style: normal
            color: var(--wasabi) !important

        .ind
            color: var(--indigo-l) !important

    .brand-sub
        font-size: 14.5px
        font-weight: 400
        color: rgba(255, 255, 255, .62) !important
        line-height: 1.6
        max-width: 30ch
        margin-top: 18px

        b
            color: #fff !important
            font-weight: 600

    .stats
        margin-top: auto
        display: flex
        gap: 30px
        padding-top: 30px
        border-top: 1px solid rgba(255, 255, 255, .12)

    .stat
        .v
            font-family: 'Geologica', sans-serif
            font-size: 25px
            font-weight: 900
            letter-spacing: -.04em
            color: #fff !important
            line-height: 1
            white-space: nowrap

            em
                font-style: normal
                color: var(--wasabi) !important

        .l
            font-size: 11.5px
            font-weight: 400
            color: rgba(255, 255, 255, .5) !important
            margin-top: 7px
            line-height: 1.3

            span
                color: inherit !important

    .actions
        position: relative
        padding: 36px 34px 28px
        background: var(--bg)
        display: flex
        flex-direction: column
        gap: 16px
        min-height: 0
        min-width: 0
        max-width: 100%
        overflow: hidden

    .actions-top
        position: static
        z-index: auto
        min-height: 44px
        flex: 0 0 auto
        display: flex
        align-items: center
        justify-content: flex-end
        gap: 8px

    .actions-main
        display: flex
        flex-direction: column
        gap: 14px
        flex: 1 1 auto
        justify-content: center
        margin: 0
        min-width: 0
        max-width: 100%

    .btn
        display: inline-flex
        align-items: center
        justify-content: center
        gap: 8px
        border-radius: var(--r-md)
        font-family: 'Geologica', sans-serif
        font-weight: 800
        cursor: pointer
        border: none
        transition: filter .18s, transform .18s, background .18s
        letter-spacing: -.01em
        white-space: nowrap

        svg
            flex-shrink: 0
            transition: transform .2s ease

    .btn-nav
        min-height: 40px
        border-radius: 12px
        padding: 10px 18px
        font-size: 13px
        box-shadow: 0 8px 22px rgba($dark-new, .08)

    .btn-nav-login
        background: #fff
        color: var(--indigo) !important
        border: 1.5px solid rgba($main-new, .14)

        &:hover
            background: var(--indigo-tint)
            border-color: rgba($main-new, .34)
            transform: translateY(-1px)

    .btn-nav-signup
        background: var(--indigo)
        color: #fff !important
        border: 1.5px solid transparent
        box-shadow: 0 8px 22px rgba($main-new, .28)

        &:hover
            background: var(--indigo-d)
            transform: translateY(-1px)

    .btn-indigo
        background: var(--indigo)
        color: #fff !important
        font-size: 14px
        padding: 13px 22px
        box-shadow: 0 6px 20px rgba($main-new, .3)

        &:hover
            background: var(--indigo-d)
            transform: translateY(-1px)

    .btn-outline
        background: var(--surface)
        color: var(--indigo) !important
        font-size: 14px
        padding: 12px 20px
        border: 1.5px solid rgba($main-new, .26)
        box-shadow: 0 6px 18px rgba($dark-new, .06)

        &:hover
            border-color: rgba($main-new, .52)
            background: var(--indigo-tint)
            transform: translateY(-1px)

    .btn-ghost
        background: transparent
        color: var(--mut) !important
        font-size: 13px
        padding: 8px 0
        box-shadow: none
        border-radius: 8px

        &:hover
            color: var(--indigo) !important

    .btn-wasabi
        background: var(--wasabi)
        color: #1A1800 !important
        font-size: 14px
        padding: 14px 22px
        box-shadow: 0 6px 22px rgba($pop-new, .4)
        flex-shrink: 0

        &:hover
            filter: brightness(1.04)
            transform: translateY(-1px)

    .door
        border-radius: var(--r-xl)
        position: relative
        overflow: hidden
        display: flex
        flex-direction: column
        transition: transform .22s ease, box-shadow .22s ease, border-color .22s ease

        > *
            position: relative
            z-index: 1

        &::before
            content: ''
            position: absolute
            top: 0
            left: 0
            right: 0
            height: 4px
            z-index: 3

        &:hover .btn svg
            transform: translateX(3px)

    .door-num
        position: absolute
        top: 8px
        right: 20px
        z-index: 0
        font-family: 'Geologica', sans-serif
        font-weight: 900
        font-size: 78px
        line-height: 1
        letter-spacing: -.06em
        pointer-events: none

    .door-platform
        background: var(--surface)
        border: 1.5px solid var(--line)
        padding: 24px 28px
        box-shadow: var(--sh-md)

        &::before
            background: linear-gradient(90deg, var(--indigo), var(--indigo-l))

        .door-num
            color: transparent !important
            -webkit-text-stroke: 1.6px rgba($main-new, .16)

        &:hover
            transform: translateY(-3px)
            border-color: rgba($main-new, .45)
            box-shadow: 0 20px 44px rgba($main-new, .16)

            .link-try
                transform: translateX(2px)

    .door-head
        display: flex
        align-items: flex-start
        gap: 16px

    .door-icon
        width: 50px
        height: 50px
        border-radius: 14px
        display: flex
        align-items: center
        justify-content: center
        flex-shrink: 0

        svg
            width: 25px
            height: 25px

    .icon-platform
        background: var(--indigo)
        color: #fff !important
        box-shadow: 0 6px 18px rgba($main-new, .32)

    .door-htext
        flex: 1
        min-width: 0

    .door-kicker
        display: inline-flex
        align-items: center
        gap: 6px
        font-family: 'Geologica', sans-serif
        font-size: 10px
        font-weight: 800
        letter-spacing: .08em
        text-transform: uppercase
        color: var(--indigo) !important
        margin-bottom: 5px

        .d
            width: 5px
            height: 5px
            border-radius: 50%
            background: var(--indigo)

    .door-title
        font-family: 'Geologica', sans-serif
        font-size: 23px
        font-weight: 900
        letter-spacing: -.035em
        line-height: 1.05
        color: var(--ink) !important

    .door-desc
        font-size: 13.5px
        font-weight: 400
        color: var(--mut) !important
        line-height: 1.55
        margin-top: 14px

    .tags
        display: flex
        flex-wrap: wrap
        gap: 7px
        margin-top: 14px

    .tag
        display: inline-flex
        align-items: center
        gap: 6px
        font-size: 12px
        font-weight: 500
        color: var(--text) !important
        background: var(--indigo-tint)
        border: 1px solid rgba($main-new, .14)
        border-radius: 8px
        padding: 5px 10px

        svg
            width: 12px
            height: 12px
            color: var(--indigo) !important

    .door-foot
        display: flex
        align-items: center
        gap: 14px
        margin-top: 18px

    .auth-cta
        display: flex
        align-items: center
        gap: 10px
        flex-wrap: wrap
        flex-shrink: 0

        .btn
            min-height: 44px

    .link-try
        font-size: 13px
        font-weight: 600
        color: var(--mut) !important
        transition: color .15s ease, transform .2s ease

        b
            color: inherit !important
            font-family: 'Geologica', sans-serif

        &:hover
            color: var(--indigo) !important

    .pmeta
        margin-left: auto
        text-align: right

        .pv
            font-family: 'Geologica', sans-serif
            font-size: 15px
            font-weight: 900
            letter-spacing: -.03em
            color: var(--ink) !important
            white-space: nowrap

        .pl
            font-size: 10.5px
            color: var(--mut2) !important
            margin-top: 1px

    .door-market
        background: var(--ink)
        color: #fff !important
        padding: 22px 26px
        position: relative
        overflow: hidden

        &::before
            background: var(--wasabi)

        &::after
            content: ''
            position: absolute
            width: 300px
            height: 300px
            right: -110px
            bottom: -150px
            border-radius: 50%
            background: radial-gradient(circle, rgba($pop-new, .32), transparent 70%)
            filter: blur(10px)
            pointer-events: none

        .door-num
            color: transparent !important
            -webkit-text-stroke: 1.6px rgba($pop-new, .34)

        &:hover
            transform: translateY(-3px)
            box-shadow: 0 20px 48px rgba($dark-new, .34)

    .market-row
        position: relative
        display: flex
        align-items: center
        gap: 20px

    .icon-market
        width: 50px
        height: 50px
        border-radius: 14px
        background: var(--wasabi)
        color: var(--ink) !important
        display: flex
        align-items: center
        justify-content: center
        flex-shrink: 0

        svg
            width: 25px
            height: 25px

    .market-text
        flex: 1
        min-width: 0

    .ad-label
        display: inline-flex
        align-items: center
        gap: 7px
        font-family: 'Geologica', sans-serif
        font-size: 9.5px
        font-weight: 800
        letter-spacing: .1em
        text-transform: uppercase
        color: var(--wasabi) !important
        margin-bottom: 4px

        .b
            font-size: 8.5px
            color: rgba(255, 255, 255, .45) !important
            border: 1px solid rgba(255, 255, 255, .2)
            border-radius: 4px
            padding: 1px 5px
            letter-spacing: .06em

    .market-title
        font-family: 'Geologica', sans-serif
        font-size: 20px
        font-weight: 900
        letter-spacing: -.035em
        line-height: 1.05
        color: #fff !important

    .market-desc
        font-size: 12.5px
        font-weight: 400
        color: rgba(255, 255, 255, .6) !important
        line-height: 1.5
        margin-top: 6px
        max-width: 42ch

    .door-system-footer
        background: var(--surface)
        border: 1px solid var(--line)
        box-shadow: 0 10px 24px rgba($dark-new, .07)
        padding: 14px 16px
        gap: 10px

        &::before
            background: linear-gradient(90deg, var(--wasabi), var(--indigo))
            height: 3px

        .door-num
            display: none

    .system-integrations
        display: flex
        align-items: center
        gap: 8px
        flex-wrap: wrap
        min-width: 0
        padding-right: 54px

        .int-label
            font-family: 'Geologica', sans-serif
            font-size: 10.5px
            font-weight: 700
            color: var(--mut2) !important
            letter-spacing: .02em

        .int-chip
            font-family: 'Geologica', sans-serif
            font-size: 10.5px
            font-weight: 700
            padding: 3px 8px
            line-height: 1.15
            background: var(--surface)
            border: 1px solid var(--line)
            border-radius: 7px
            color: var(--mut) !important

    .system-footer-separator
        height: 1px
        background: var(--line2)
        width: 100%

    .system-footer-grid
        display: grid
        grid-template-columns: minmax(0, 1fr) minmax(240px, auto)
        gap: 16px
        align-items: center
        min-width: 0

    .system-footer-contact
        display: flex
        align-items: center
        flex-direction: row
        flex-wrap: wrap
        gap: 8px 14px
        min-width: 0
        color: var(--mut) !important
        font-size: 12px
        line-height: 1.25

        a
            color: var(--mut) !important
            text-decoration: none
            white-space: nowrap

            &:hover
                color: var(--indigo) !important
                text-decoration: underline
                text-underline-offset: 3px

    .system-footer-support
        display: flex
        align-items: center
        gap: 8px
        justify-content: flex-end
        padding: 4px 6px 4px 8px
        border-radius: 14px
        background: #F7F8FF
        border: 1px solid rgba($main-new, .12)
        box-shadow: 0 6px 18px rgba($main-new, .06)
        min-width: 0

    .system-footer-support-title
        font-family: 'Geologica', sans-serif
        font-size: 12.6px
        font-weight: 900
        margin-right: 4px
        color: var(--ink) !important
        white-space: nowrap

    .system-support-btn
        min-height: 36px
        display: inline-flex
        align-items: center
        justify-content: center
        padding: 9px 15px
        border-radius: 11px
        background: var(--indigo)
        color: #fff !important
        font-family: 'Geologica', sans-serif
        font-size: 12.4px
        font-weight: 900
        white-space: nowrap
        box-shadow: 0 8px 18px rgba($main-new, .18)
        transition: background .15s, transform .15s

        &:hover
            background: var(--indigo-d)
            transform: translateY(-1px)

        &.system-support-btn--secondary
            background: #fff
            color: var(--indigo) !important
            border: 1px solid rgba($main-new, .24)
            box-shadow: 0 8px 18px rgba($main-new, .06)

            &:hover
                background: #F4F5FF
                color: var(--indigo-d) !important

    .system-footer-bottomline
        display: flex
        align-items: center
        justify-content: space-between
        gap: 14px
        border-top: 1px solid var(--line2)
        padding-top: 8px

    .system-copy
        font-size: 10.8px
        color: var(--mut2) !important
        white-space: nowrap

    .system-grant-note
        font-size: 9.6px
        line-height: 1.25
        color: var(--mut) !important
        text-transform: uppercase
        text-align: right

    @media (prefers-reduced-motion: reduce)
        *
            animation: none !important

    @media (max-width: 1280px) and (min-width: 921px)
        .actions
            padding: 24px 28px 24px

        .actions-top
            min-height: 40px

        .actions-main
            gap: 12px

        .door-platform
            padding: 20px 24px

        .door-icon, .icon-market
            width: 46px
            height: 46px
            border-radius: 13px

        .door-title
            font-size: 22px

        .door-desc
            font-size: 13px
            line-height: 1.45
            margin-top: 12px

        .tags
            gap: 6px
            margin-top: 12px

        .tag
            font-size: 11.5px
            padding: 4px 8px

        .door-foot
            gap: 10px
            margin-top: 14px

        .auth-cta
            gap: 8px

            .btn
                min-height: 40px

        .btn-indigo
            padding: 11px 18px

        .btn-outline
            padding: 10px 16px

        .btn-ghost
            font-size: 12.5px

        .pmeta .pv
            font-size: 14px

        .door-market
            padding: 18px 24px

        .market-row
            gap: 16px

        .market-title
            font-size: 19px

        .market-desc
            font-size: 12px
            line-height: 1.45

        .btn-wasabi
            padding: 12px 18px

        .door-system-footer
            padding: 10px 14px
            gap: 8px

        .system-integrations
            gap: 6px
            padding-right: 44px

            .int-chip
                font-size: 10px
                padding: 3px 7px

        .system-footer-bottomline
            padding-top: 6px

        .system-grant-note
            font-size: 8.8px

    @media (max-width: 1100px) and (min-width: 921px)
        .system-grant-note
            display: none

        .system-footer-bottomline
            justify-content: flex-start

    @media (max-height: 780px) and (min-width: 921px)
        .actions
            padding-top: 18px
            padding-bottom: 18px
            gap: 10px

        .actions-top
            min-height: 40px

        .actions-main
            gap: 10px

        .door-platform
            padding: 20px 24px

        .door-desc, .tags
            margin-top: 12px

        .door-foot
            margin-top: 14px

        .door-market
            padding: 18px 24px

        .door-system-footer
            padding: 12px 14px

        .system-footer-bottomline
            padding-top: 7px

    @media (max-width: 920px)
        height: auto
        min-height: 100vh
        overflow-x: hidden
        overflow-y: auto

        .split
            grid-template-columns: 1fr
            min-height: auto
            height: auto

        .brand
            padding: 36px 28px

        .brand h1
            margin-top: 22px

        .stats
            margin-top: 26px

        .actions
            padding: 32px 24px 24px

        .actions-top
            margin-bottom: 0

        .actions-main
            margin: 0

        .market-row
            flex-direction: column
            align-items: flex-start
            gap: 16px

        .btn-wasabi
            width: 100%

        .door-system-footer
            padding: 14px 16px

        .system-footer-grid
            grid-template-columns: 1fr
            align-items: start

        .system-footer-contact
            flex-direction: row
            flex-wrap: wrap
            gap: 8px 12px

        .system-footer-support
            justify-content: flex-start
            flex-wrap: wrap
            width: 100%
            padding: 10px 10px 10px 12px
            gap: 8px

        .system-footer-support-title
            flex: 1 0 100%
            margin-right: 0
            margin-bottom: 2px
            text-align: center

        .system-support-btn
            flex: 1 1 0
            min-width: 0

        .system-footer-bottomline
            align-items: flex-start
            flex-direction: column
            gap: 6px

        .system-grant-note
            text-align: left

    @media (max-width: 700px)
        .system-footer-grid
            grid-template-columns: 1fr

        .system-footer-support
            width: 100%

        .system-support-btn
            min-height: 40px
            padding: 10px 12px
            font-size: 12px

    @media (max-width: 560px)
        .door-foot
            flex-wrap: wrap

        .auth-cta
            width: 100%

            .btn
                flex: 1

        .btn-ghost
            padding-left: 0

        .pmeta
            margin-left: 0
            text-align: left
            width: 100%

        .stats
            flex-wrap: wrap
            gap: 20px

        .brand-logo-img
            width: 132px
            max-height: 40px

        .system-integrations
            padding-right: 40px
</style>
